import type { TimeRange } from "Types/OpeningHours";
import { TimeRangeInput } from "../TimeRangeInput";
import { Stack } from "@mui/material";

type Props = {
  ranges: Array<TimeRange>;
  onChange: (index: number, newRange: TimeRange) => void;
  onDelete: (index: number) => void;
};

export const TimeRangeList = ({ ranges, onChange, onDelete }: Props) => (
  <Stack gap={{ xs: 4, sm: 2 }}>
    {ranges.map((range, index) => (
      <TimeRangeInput
        key={range.id}
        range={range}
        onDelete={() => onDelete(index)}
        onChange={(newRange) => onChange(index, newRange)}
      />
    ))}
  </Stack>
);
